module.exports = __webpack_public_path__ + "img/fsa-store-logo-purple.3c965151.png";